module.exports = require("crypto-js");


//////////////////
// WEBPACK FOOTER
// external "crypto-js"
// module id = 8
// module chunks = 0